import React, { useRef, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { observer } from 'mobx-react';
import stores from 'cd-eft/models/Stores';
import { Alert } from '../../common/Alert/Alert';
import { SurveyPointsDataGridVM, headerSelection } from './SurveyPointsDataGridVM';
import { UploadSurveyPoints } from '../UploadSurveyPoints/UploadSurveyPoints';
import { Table, CustomInput } from 'reactstrap';
import { Notification } from 'cd-eft/components/common/Notification';
import './surveyPointsDataGrid.scss';
import { Accordion } from 'cd-eft/components/common/Accordion';
import { mdiMenuDown } from '@mdi/js';
import Icon from '@mdi/react';

const { projectsLibraryStore: libraryStore, designStore, surveyEngineeringStore: setStore } = stores.AppStore;
const SurveyPointsDataGridComponent = (props) => {
  const history = useHistory();
  const vm = useRef(new SurveyPointsDataGridVM(props)).current;

  useEffect(function () {
    if (!designStore.hasProject()) {
      vm.noProjecMessage(history);
      return;
    }
    vm.setUniqueDescriptions();
  }, []);

  useEffect(() => {
    if (vm.newSurvey.coordinateSystemType) {
      vm.projectionByLocation();
    }
  }, [vm.newSurvey.coordinateSystemType]);

  useEffect(
    function mount() {
      function unmount() {
        props.stopWatchHandler();
      }
      return unmount;
    }, []
  )



  return (
    <>
      <div className="set-data-grid-container">
         {(!setStore.surveyEditMode) ? (
              renderFieldsetContent(vm)
            ) : (
               <Accordion
                  headers={[setStore.isHeaderAccepted ? setStore.currentSurvey.surveyName : vm.newSurvey.surveyName]}
                  onToggle={() => vm.toggleAccordion()}
                >
                  {renderFieldsetContent(vm)}
                </Accordion>
          )}
         {/* section for new survey with header selectors */}
         {setStore.hasGrid && !setStore.isHeaderAccepted && (
          <>
            {vm.error && <Alert show={vm.error} type="error" msg={vm.errorMsg} />}

            <div className={`set-data-grid-table ${vm.isAccordionExpanded ? '' : 'set-data-grid-table-expanded'}`}>
              <Table className="set-table">
                <thead className="set-grid-table-head">
                  <tr>
                    {/* <th className="p-2">Select</th> */}
                    <th hidden>Id</th>
                    <HeaderSelection getColumnHeader={vm.getColumnHeader} number={0} />
                    <HeaderSelection getColumnHeader={vm.getColumnHeader} number={1} />
                    <HeaderSelection getColumnHeader={vm.getColumnHeader} number={2} />
                    <HeaderSelection getColumnHeader={vm.getColumnHeader} number={3} />
                    <HeaderSelection getColumnHeader={vm.getColumnHeader} number={4} />
                    <th>Visible</th>
                    <th>Tinable</th>
                  </tr>
                </thead>
                <tbody>
                  {setStore.tempXYZPointsTable &&
                    setStore.tempXYZPointsTable.map((item: any, i: number) => {
                      return (
                        i < setStore.initTempXYZPointsLength && (
                          <tr key={'key-' + i + '-' + item[0]}>
                            {/* <td className="text-center">
                              <input
                                id={'select' + i}
                                name="select"
                                data-testid={'select' + i}
                                type="checkbox"
                                value={i}
                                checked={vm.checkboxes.includes(i)}
                                onChange={vm.toggleCheckbox}
                                disabled={true}
                              />
                            </td> */}
                            <td hidden>{i}</td>
                            <td>{item[0]}</td>
                            <td>{item[1]}</td>
                            <td>{item[2]}</td>
                            <td>{item[3]}</td>
                            <td>{item[4]}</td>
                            <td className="text-center">
                              <input
                                id={'visible' + i}
                                name="visible"
                                type="checkbox"
                                value={1}
                                checked={true}
                                data-i={i}
                                onChange={vm.handleCheckboxChange}
                                disabled={true}
                              />
                            </td>
                            <td className="text-center">
                              <input
                                id={'tinable' + i}
                                name="tinable"
                                type="checkbox"
                                value={1}
                                checked={true}
                                data-i={i}
                                onChange={vm.handleCheckboxChange}
                                disabled={true}
                              />
                            </td>
                          </tr>
                        )
                      );
                    })}
                </tbody>
              </Table>
            </div>
            <div className="form-row-fixed-height justify-content-end mt-4">
              <button className="usa-button" onClick={vm.onClickAcceptHeader} hidden={setStore.isHeaderAccepted}>
                Accept Header
              </button>
              <button className="usa-button m-0" onClick={vm.onClickCancelXYZSurvey}>
                Close Edit
              </button>
            </div>
          </>
        )}

        {/* 2nd block  original xyzPointsTable*/}
        {setStore.hasGrid && setStore.isHeaderAccepted && (
          <div>
            <Alert show={vm.error} type="error" msg={vm.errorMsg} />
            <div className={`set-data-grid-table ${vm.isAccordionExpanded ? '' : 'set-data-grid-table-expanded'}`}>
              <Table className="set-table">
                <thead className="set-grid-table-head">
                  <tr>
                    {/* <th className="p-2">Select</th> */}
                    <th hidden>Id</th>
                    <th className="pl-2">Name</th>
                    <th>X(Easting)</th>
                    <th>Y(Northing)</th>
                    <th>Z(Elevation)</th>
                    {setStore.currentSurvey.surveyId ? (
                      <th>
                        <select
                        aria-label="Description"
                        className="th-with-select usa-select"
                        name={"Description"}
                        value={setStore.pointDescriptionFilter}
                        onChange={(e) => vm.setDescriptionFilter(e.target.value)}
                        >
                          <option value='All'>{"Description"}</option>
                          {vm.uniqueDescriptions.length > 0 && vm.uniqueDescriptions.map((value, index) => (
                            <option key={`Description-${index}`} value={value}>
                                {value}
                            </option>
                          ))}
                        </select>
                      </th>
                    ) : (
                      <th>Description</th>
                    )}
                    <th className="pl-1">
                      Visible
                      {setStore.isHeaderAccepted && (
                        <div 
                          className="select-dropdown"
                          id={'visible-select-deselect-button'}
                          onClick={() => {
                            if (document.getElementById('visible-select-deselect-button')) {
                              const el = document.getElementById('visible-select-deselect-button');
                              el?.blur();
                            }
                          }}
                        >
                          <button className="usa-button usa-button--unstyled text-no-underline">
                            <span style={{ color: 'black', fontWeight: 'bold' }}>Select</span>
                            <Icon path={mdiMenuDown} title="Select Dropdown" style={{ color: 'black' }} size={1.2} />
                          </button>
                          <div className="select-menu">
                            <button key = "visible-deselect" className="usa-button usa-button--unstyled select-menu-item" onClick={(e) => {
                              const el = document.activeElement as HTMLElement;
                              el?.blur();
                              vm.handleSelectAll('visible', false);
                              }}
                            >Unselect</button>
                            <button key = "visible-select" className="usa-button usa-button--unstyled select-menu-item" onClick={(e) => {
                              const el = document.activeElement as HTMLElement;
                              el?.blur();
                              vm.handleSelectAll('visible', true);
                              }}
                            >Select</button>                                          
                          </div>
                   
                        </div>
                      )}
                    </th>
                    <th className="pl-1">
                      Tinable
                      {setStore.isHeaderAccepted && (
                        <div 
                          className="select-dropdown"
                          id={'tinable-select-deselect-button'}
                          onClick={() => {
                            if (document.getElementById('tinable-select-deselect-button')) {
                              const el = document.getElementById('tinable-select-deselect-button');
                              el?.blur();
                            }
                          }}
                        >
                          <button className="usa-button usa-button--unstyled text-no-underline">
                            <span style={{ color: 'black', fontWeight: 'bold' }}>Select</span>
                            <Icon path={mdiMenuDown} title="Select Dropdown" style={{ color: 'black' }} size={1.2} />
                          </button>
                          <div className="select-menu">
                            <button key = "tinable-deselect" className="usa-button usa-button--unstyled select-menu-item" onClick={(e) => {
                              const el = document.activeElement as HTMLElement;
                              el?.blur();
                              vm.handleSelectAll('tinable', false);
                              }}
                            >Unselect</button>
                            <button key = "tinable-select" className="usa-button usa-button--unstyled select-menu-item" onClick={(e) => {
                              const el = document.activeElement as HTMLElement;
                              el?.blur();
                              vm.handleSelectAll('tinable', true);
                              }}
                            >Select</button>                                          
                          </div>
                   
                        </div>
                      )}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {setStore.xyzPointsTable && setStore.xyzPointsTable.map((item: any, i: number) => {
                    if (item.editing_status === 'delete') return false;
                    if (setStore.pointDescriptionFilter !== "All" && item.description !== setStore.pointDescriptionFilter) {
                      item.filtered = false;
                      return null;
                    }
                    item.filtered = true;
                    return i < setStore.initXYZPointsLength ? (
                      <tr
                        id={'key-xyzSurveyPoint-' + i}
                        key={'key-' + i + '-' + item.id}
                        className={item.hasDuplicate ? 'highlightedRow' : ''}
                        onMouseEnter={() => vm.handleRowMouseEnter(item)}
                        onMouseLeave={vm.handleRowMouseLeave}
                      >
                        {/* <td className="text-center">
                          <input
                            id={'select' + i}
                            name="select"
                            data-testid={'select' + i}
                            type="checkbox"
                            value={i}
                            checked={vm.checkboxes.includes(i)}
                            onChange={vm.toggleCheckbox}
                          />
                        </td> */}
                        <td hidden>{i}</td>
                        <td width="15%">
                          <input
                            className={'usa-input'}
                            type="text"
                            name="pointName"
                            aria-label={`point name-${i}`}
                            value={item.pointName}
                            data-i={i}
                            onChange={vm.handleOnChangeEdit}
                          />
                        </td>
                        <td>{item.x}</td>
                        <td>{item.y}</td>
                        <td>{item.z}</td>
                        <td width="15%">
                          <input
                            className={'usa-input'}
                            type="text"
                            name="featureDescription"
                            value={item.featureDescription}
                            aria-label={`point description-${i}`}
                            data-i={i}
                            onChange={vm.handleOnChangeEdit}
                            onBlur={vm.setUniqueDescriptions}
                          />
                        </td>
                        <td className="text-center">
                          <input
                            id={'visible' + i}
                            name="visible"
                            type="checkbox"
                            aria-label={`point visible-${i}`}
                            value={item.visible}
                            checked={item.visible}
                            data-i={i}
                            disabled={!setStore.isHeaderAccepted}
                            onChange={vm.handleCheckboxChange}
                          />
                        </td>
                        <td className="text-center">
                          <input
                            id={'tinable' + i}
                            name="tinable"
                            type="checkbox"
                            aria-label={`point tinable-${i}`}
                            value={item.tinable}
                            checked={item.tinable}
                            data-i={i}
                            disabled={!setStore.isHeaderAccepted}
                            onChange={vm.handleTinableCheckboxChange}
                          />
                        </td>
                      </tr>
                    ) : (
                      <tr key={'key-' + i + '-' + item.id}>
                        <td className="text-center">
                          <input
                            id={'select' + i}
                            name="select"
                            type="checkbox"
                            value={i}
                            checked={vm.checkboxes.includes(i)}
                            onChange={vm.toggleCheckbox}
                          />
                        </td>
                        <td hidden>{item.id}</td>
                        <td>
                          <input
                            className={'usa-input'}
                            type="text"
                            name="pointName"
                            value={item.pointName}
                            data-i={i}
                            onChange={vm.handleOnChange}
                          />
                        </td>
                        <td>
                          <input
                            className={'usa-input'}
                            type="number"
                            name="x"
                            value={item.x}
                            data-i={i}
                            onChange={vm.handleOnChange}
                          />
                        </td>
                        <td>
                          <input
                            className={'usa-input'}
                            type="number"
                            name="y"
                            value={item.y}
                            data-i={i}
                            onChange={vm.handleOnChange}
                          />
                        </td>
                        <td>
                          <input
                            className={'usa-input'}
                            type="number"
                            name="z"
                            value={item.z}
                            data-i={i}
                            onChange={vm.handleOnChange}
                          />
                        </td>
                        <td>
                          <input
                            className={'usa-input'}
                            type="text"
                            name="featureDescription"
                            value={item.featureDescription}
                            data-i={i}
                            onChange={vm.handleOnChange}
                          />
                        </td>
                        <td className="text-center">
                          <input
                            id={'visible' + i}
                            name="visible"
                            type="checkbox"
                            value={item.visible}
                            checked={item.visible}
                            data-i={i}
                            disabled={!setStore.currentSurvey.surveyId}
                            onChange={vm.handleCheckboxChange}
                          />
                        </td>
                        <td className="text-center">
                          <input
                            id={'tinable' + i}
                            name="tinable"
                            type="checkbox"
                            value={item.tinable}
                            checked={item.tinable}
                            data-i={i}
                            disabled={!setStore.currentSurvey.surveyId}
                            onChange={vm.handleCheckboxChange}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>

            <div className="form-row-fixed-height justify-content-between mt-4">
              <div className="display-flex align-items-center ml-4">
                {setStore.isHeaderAccepted && setStore.currentTab === 'New Survey' && (
                  <>
                    <input
                      name="displayGroundPoints"
                      id="displayGroundPoints"
                      type="checkbox"
                      className="mr-2"
                      checked={setStore.displayNewSurvey}
                      onChange={vm.displayGroundPointsHandler}
                    />
                    <label htmlFor="displayGroundPoints" className="h5 m-0 link">
                      Display ground points
                    </label>
                  </>
                )}
              </div>

              <div>
                <button className="usa-button usa-button--outline" onClick={vm.onClickCancelXYZSurvey}>
                    Close
                </button>
                {!setStore.currentSurvey.surveyId && setStore.isHeaderAccepted && (
                  <button className="usa-button m-0" onClick={vm.handleSaveXYZSurvey}>
                    Save
                  </button>
                )}
              </div>
            </div>
          </div>
        )}
        {!setStore.hasGrid && (
          <div className="text-right">
            <button className="usa-button mr-0" onClick={vm.onClickCancelXYZSurvey}>
              Close
            </button>
          </div>
        )}
        <Notification
          type={vm.notification.type}
          message={vm.notification.message}
          header={vm.notification.header}
          hidden={vm.notification.hidden}
          timestamp={vm.notification.timestamp}
        >
          <button
            className="usa-button usa-button--outline"
            hidden={!vm.notification.message.includes('project')}
            type="button"
            onClick={() => {
              history.push('/projects/new-project');
            }}
          >
            Go Create a Project
          </button>
        </Notification>
        {/* <div id="edit-map-points-menu-container" >
          <input
            id={'edit-map-points-checkbox' }
            name="tinable"
            type="checkbox"
            disabled={!setStore.currentSurvey.surveyId}
            onChange={vm.handleCheckboxChange}
          />
          <p>Tinable</p>
        </div> */}
      </div>
    </>
  );
};
export const renderFieldsetContent = (vm) => (
  <fieldset className="fieldset-padding" disabled={designStore.projectsStore.currentProject.projectUuid === ''}>        
  <div className="display-flex flex-row flex-justify-center p-6">
    <div className="new-survey-left">
      <UploadSurveyPoints />
      {setStore.hasGrid && !setStore.isHeaderAccepted ? (
        <CustomInput
          type="switch"
          id="previewSwitch"
          data-testid="previewSwitch"
          name="previewSwitch"
          label="Preview"
          checked={vm.previewProjectedSurvey}
          onChange={vm.previewSurveySwitchHandler}
        />
      ) : null}
    </div>
    
    <div>
      <div className="form-row-fixed-height name-field-padding">
        <label className="usa-label label-with-fixed-width" htmlFor="surface-name">
          Surface Name:
        </label>
        <input
          className={vm.formValidation.formErrors.surfaceName !== '' ? ' usa-input--error' : 'usa-input'}
          id="surfaceName"
          aria-label="surfaceName"
          name="surfaceName"
          type="text"
          placeholder="Surface Name...."
          value={
            setStore.isHeaderAccepted ? designStore.currentSurface.surfaceDefTitle : vm.newSurface.surfaceName
          }
          onChange={vm.setSurfaceName}
          disabled={setStore.isHeaderAccepted}
        />
      </div>
      <span className="usa-error-message" id="client--message" role="alert">
        {vm.formValidation.formErrors.surfaceName}
      </span>
      <div className="form-row-fixed-height name-field-padding">
        <label className="usa-label label-with-fixed-width" htmlFor="surveyname">
          Survey Name:
        </label>
        <input
          className={vm.formValidation.formErrors.surveyName !== '' ? ' usa-input--error' : 'usa-input'}
          id="surveyName"
          aria-label="surveyName"
          name="surveyName"
          type="text"
          placeholder="Survey Name...."
          value={setStore.isHeaderAccepted ? setStore.currentSurvey.surveyName : vm.newSurvey.surveyName}
          onChange={vm.setSurveyName}
          disabled={setStore.isHeaderAccepted}
        />
      </div>
      <span className="usa-error-message" id="client--message" role="alert">
        {vm.formValidation.formErrors.surveyName}
      </span>
      <div className="form-row-fixed-height">
        <label className="usa-label label-with-fixed-width" htmlFor="coordinateSystemType">
          Coordinate System Type:
        </label>
        <select
          className={vm.formValidation.formErrors.coordinateSystemType !== '' ? ' usa-select--error' : 'usa-select'}
          name="coordinateSystemType"
          id="coordinateSystemType"
          aria-label="Coordinate System Type"
          data-testid="coordinateSystemType-select"
          value={vm.newSurvey.coordinateSystemType}
          onChange={(e) => vm.handleCoordinateSystemChange(e)}
        >
          <option value="" disabled={(setStore.surveySummaryTable && setStore.surveySummaryTable.length > 0)}> - select - </option>
          {libraryStore.coordinateSystemOptions.map((el) => (
            <option
              value={el.value}
              key={el.value}
              label={el.label}
              disabled={(setStore.surveySummaryTable && setStore.surveySummaryTable.length > 0)}
            >
              {el.name}
            </option>
          ))}
        </select>
      </div>
      <span className="usa-error-message" id="client--message" role="alert">
        {vm.formValidation.formErrors['coordinateSystemType'] && (
          <div>Coordinate System Type {vm.formValidation.formErrors['coordinateSystemType']}</div>
        )}
      </span>
      {/* Zone */}
      {libraryStore.pojectionByLocationData.length === 1 || libraryStore.pojectionByLocationData.length === 0 ? (
        <>
          <div className="form-row-fixed-height">
            <label className="usa-label label-with-fixed-width" htmlFor="zone">
              Zone:
            </label>
            <input
              className={'usa-input'}
              id="zone"
              aria-label="Zone"
              name="zone"
              type="text"
              value={libraryStore.pojectionByLocationData.length === 1 ? libraryStore.pojectionByLocationData[0].zoneName : ''}
              onChange={vm.handleZoneInputChange}
              readOnly
            />
          </div>
        </>
      ) : (
        <>
          <div className="form-row-fixed-height">
            <label className="usa-label label-with-fixed-width" htmlFor="zone">
              Zone:
            </label>
            <select
              className={vm.formValidation.formErrors.zone !== '' ? ' usa-select--error' : 'usa-select'}
              name="zone"
              id="zone"
              aria-label="zone"
              data-testid="zone-select"
              value={vm.newSurvey.zone}
              defaultValue={libraryStore.projectSpatialRefData.zone}
              onChange={vm.handleZoneInputChange}
            >
              <option value="" disabled={(setStore.surveySummaryTable && setStore.surveySummaryTable.length > 0)}> - select - </option>
              {libraryStore.pojectionByLocationData.map((el) => (
                <option value={el.zoneName} key={el.zoneName} label={el.zoneName}
                  disabled={(setStore.surveySummaryTable && setStore.surveySummaryTable.length > 0)}
                >
                  {el.zoneName}
                </option>
              ))}
            </select>
          </div>
        </>               
      )}
      <span className="usa-error-message" id="client--message" role="alert">
            {vm.formValidation.formErrors['zone'] && (
              <div>Zone {vm.formValidation.formErrors['zone']}</div>
            )}
      </span>
      <ContourIntervalSelect  vm={vm}/>
    </div>
   
  </div>
 
</fieldset>
);
export const SurveyPointsDataGrid = observer(SurveyPointsDataGridComponent);

export const getHeaderOptions = (isNumType) => {
  const listOfOptions = isNumType
    ? setStore.numberOfNumericFields > 3
      ? 'allOptions'
      : 'numOptions'
    : setStore.numberOfNumericFields < 3
      ? 'allOptions'
      : 'stringOptions';

  return headerSelection[listOfOptions].map((option) => (
    <option value={option.value} key={option.label}>
      {option.label}
    </option>
  ));
};

export const HeaderSelection = observer((props) => {
  const { getColumnHeader, number } = props;
  return (
    <th>
      <select
        className="th-with-select usa-select"
        name={`column${number}`}
        onChange={(e) => getColumnHeader(e, number)}
        value={setStore.surveyFileHeader[number]}
      >
        {getHeaderOptions(setStore.numHeaderType.length > 0 && setStore.numHeaderType[number])}
      </select>
    </th>
  );
});
const ContourIntervalSelect = observer((props) => {
  return (
    <>
      <div className="form-row-fixed-height name-field-padding">
        <label className="usa-label label-with-fixed-width" htmlFor="survey_contour_interval">
          Contour Interval:
        </label>
        <select
          className="usa-select"
          name="survey_contour_interval"
          id="survey_contour_interval"
          data-testid="survey_contour_interval"
          value={designStore.contourInterval}
          onChange={(e) => {
            const value: number = parseFloat(e.target.value);
            props.vm!.setContourInterval(value);
            if(setStore.isHeaderAccepted){
              setStore.triggerSurfaceDesignerVm?.editSurveyContourInterval(Number(value));
            }
          }}
        >
          <option value={0.5} label="0.5 ft">
            0.5 ft
          </option>
          <option value={1.0} label="1.0 ft">
            1.0 ft
          </option>
          <option value={2.0} label="2.0 ft">
            2.0 ft
          </option>
          <option value={5.0} label="5.0 ft">
            5.0 ft
          </option>
          <option value={10.0} label="10.0 ft">
            10.0 ft
          </option>
        </select>
      </div>
    </>
  );
});